<template>
  <div class="extraction-template-item-actions">
    <extraction-template-modified-status-chip
      v-if="showChip"
      :item-style="itemStyle"
    />
    <v-icon
      v-if="showEditIcon"
      :disabled="isDeleted"
      class="material-icons-outlined"
      :class="iconClass"
      @click="$emit('edit')"
    >
      edit
    </v-icon>
    <v-icon
      v-if="!isDeleted"
      class="material-icons-outlined"
      :class="iconClass"
      @click="$emit('delete')"
    >
      delete
    </v-icon>
    <v-tooltip v-else top open-delay="500">
      <template #activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          class="material-icons-outlined"
          :class="iconClass"
          tabindex="-1"
          v-on="on"
          @click.stop="$emit('revert')"
        >
          undo
        </v-icon>
      </template>
      <span>{{ revertTooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { ExtractionTemplateItemStyle } from '@/enums';
import ExtractionTemplateModifiedStatusChip from './ExtractionTemplateModifiedStatusChip.vue';

export default {
  name: 'ExtractionTemplateItemActions',
  components: {
    ExtractionTemplateModifiedStatusChip,
  },
  props: {
    showEditIcon: {
      type: Boolean,
      default: false,
    },
    isHeaderItem: {
      type: Boolean,
      default: false,
    },
    itemStyle: {
      type: String,
      default: ExtractionTemplateItemStyle.DEFAULT,
      validator: (val) =>
        Object.values(ExtractionTemplateItemStyle).includes(val),
    },
  },
  emits: ['edit', 'delete', 'revert'],
  computed: {
    iconClass() {
      if (this.isHeaderItem) {
        return null;
      }
      return 'hover-icon';
    },
    revertTooltip() {
      if (this.isHeaderItem) {
        return 'Restore removed heading';
      }
      return 'Restored removed field';
    },
    isDeleted() {
      return this.itemStyle === ExtractionTemplateItemStyle.DELETED;
    },
    showChip() {
      return this.itemStyle != ExtractionTemplateItemStyle.DEFAULT;
    },
  },
};
</script>

<style lang="scss" scoped>
.extraction-template-item-actions {
  display: flex;
  gap: 1.5rem;
}

.hover-icon {
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
}
</style>
